'use client'

import type { DefaultCellComponentProps } from 'payload'

export function InstagramThumbnailCell({ cellData, rowData }: DefaultCellComponentProps) {
  const src = (cellData as string | undefined) || (rowData?.mediaUrl as string | undefined)

  if (!src) return <span>—</span>

  return (
    <img
      src={src}
      alt=""
      style={{
        width: '48px',
        height: '48px',
        objectFit: 'cover',
        borderRadius: '4px',
        display: 'block',
      }}
    />
  )
}
